import { render, staticRenderFns } from "./embedVideo.vue?vue&type=template&id=4b260a18&scoped=true&"
import script from "./embedVideo.vue?vue&type=script&lang=js&"
export * from "./embedVideo.vue?vue&type=script&lang=js&"
import style0 from "./embedVideo.vue?vue&type=style&index=0&id=4b260a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b260a18",
  null
  
)

export default component.exports